import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'

import { isBouyguesOffer } from './isBouyguesOffer'

export function hasSelectedMobilePlan(items: CartItem[]): boolean {
  return items.some((item) => {
    if (!item.mobilePlan) return false

    return isBouyguesOffer(item.mobilePlan.selectedOffer)
  })
}

export function hasSelectedOnlineMobilePlan(items: CartItem[]): boolean {
  return items.some((item) => {
    if (!item.mobilePlan) return false

    return (
      isBouyguesOffer(item.mobilePlan.selectedOffer) &&
      item.mobilePlan.selectedOffer.type === 'ONLINE'
    )
  })
}
